import { gql } from '@apollo/client'
import { buildGraphqlQuery } from '@ztechapps/common.utils'

export const treeBlogFragment = gql`
  fragment treeBlogFragment on Blog {
    _id
    title
    status
    updatedAt
    category {
      _id
    }
  }
`

export const treeBlogQueries = buildGraphqlQuery('Blog', treeBlogFragment)
